/** @module api/survey */

import { apiCall } from '@/api/index'
import { apiV1SurveyNpsRejectPath, apiV1SurveyNpsSubmitPath } from '@/../lib/routes'

export function rejectNpsSurvey() {
  return apiCall({
    method: 'POST',
    path: apiV1SurveyNpsRejectPath()
  })
}

export function submitNpsSurvey({ npsScore, comment }) {
  return apiCall({
    method: 'POST',
    path: apiV1SurveyNpsSubmitPath(),
    payload: {
      data: {
        type: 'nps_survey_event',
        attributes: {
          npsScore,
          comment
        }
      }
    }
  })
}
